import React, { memo, useState, useEffect, useContext, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import { makeSelectCardCasesPage } from "../AllottedCases/selectors";
import { useInjectReducer } from "../../utils/injectReducer";
import { ApiDispatchContext } from "../../context/ApiContext";
import makeSelectAllottedCasesDetailsPage from "./selectors";
import reducer from "./reducer";
import path from "../../constants/pathConstants";
import CommonNavbar from "../../components/CommonNavbar";
import CaseCard from "./CaseCard";
import ErrorAlert from "../../components/ErrorAlert";
import { getUrlParameter } from "../../constants/commonFunction";
import { cardDataVendor } from "../../constants/allocatedCasesTabConstants";
import CardTabs from "../../components/CardTabs";
import { caseDetails } from "./actions";
import FilterPopUp from "../../components/FilterPopUp";
import { InvestigatorNameList } from "./InvestigatorNameList";
import { decryptData } from "../../utils/crypto";
import { SuccessMessage } from "../../components/SuccessMssgDisplay";
import { setApiReRender as setApiReRenderAction } from "./actions";

export function AllottedCasesDetailsPage({ allCases, updateCaseDetails, setApiReRender }) {
  useInjectReducer({ key: "allottedCasesDetailsPage", reducer });
  const [selectedValue, setSelectedValue] = useState();
  const [tabList, setTabList] = useState(cardDataVendor);
  const api = useContext(ApiDispatchContext);
  const [modal, setModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setModalBody] = useState("");
  const [open, setOpen] = useState(false);
  const [tabVal, setTabVal] = useState("Investigation")
  const [vendorDetails, setVendorDetails] = useState({})
  const [showSuccessMessage, setShowSuccessMessage] = useState(null)
  const toggle = () => setModal(!modal);
  let caseid = Number(getUrlParameter('case'));

  useEffect(() => {
    window.scrollTo(0, 0);
    let param = {
      "caseType": "alloted",
    }
    api.getCasesDetails(param).then(data => {
      if (data.data && data.data.success) {
        selectedCard(data.data.data.rows)
      } else {
        setModalTitle("Error");
        if (data.data.error && data.data.message) {
          setModalBody(data.data.message)
        }
        else {
          setModalBody('Please try after sometime');
        }
        toggle();
      }
    }).catch(err => {
      setModalTitle("Error");
      if (err && err.response && err.response.data && err.response.data.message) {
        setModalBody(err.response.data.message);
      } else {
        setModalBody('Please try after sometime');
      }
      toggle();
    })
  }, []);

  const selectedCard = useCallback((cards) => {
    const selectedCase = cards.find(item => item.some(field => field.label === "Case No." && field.value === Number(getUrlParameter('case'))));
    setSelectedValue([selectedCase]);
    const lobType = selectedCase.find(item => item.label === "LOB")?.value || "";
    if (lobType === "A&H") {
      const tabsToHide = ["Proposal", "Risk", "Endorsement", "Dispatch"];
      const filteredTabs = tabList?.filter(
        (tab) => !tabsToHide.includes(tab?.tabTitle)
  );
    setTabList(filteredTabs);
    }
    updateCaseDetails({ lob: selectedCase.find(item => item.label === "LOB")?.value || "" })
  }, [tabList]);

  const filterToggle = () => {
    setOpen(!open);
  }

  const addInvestigatorHandler = async () => {
    let payload = {
      filters: {
        status: 'active'
      },
      page: 0,
      pageSize: 0,
      addInvestigators: true,
      caseId: caseid,
    }
    setOpen(true)
    await api.employeeDetails(payload).then(data => {
      if (data.data && data.data.success) {
        setVendorDetails(decryptData(data.data.data))
      }
      else {
        setModalTitle("Error");
        if (data.data.error && data.data.message) {
          setModalBody(data.data.message)
        }
        else {
          setModalBody('Please try after sometime');
        }
        toggle();
      }
    }).catch((err) => {
      setModalTitle("Error");
      if (err && err.response && err.response.data && err.response.data.message) {
        setModalBody(err.response.data.message);
      } else {
        setModalBody('Please try after sometime');
      }
      toggle();
    })
  }
  const assignInvestigatorHandler = (caseId, selectedEmpId) => {
    let param = {
      case_id: [Number(caseId)],
      assigned_to_investigator: selectedEmpId
    };
    api.assignInvestigator(param)
      .then((data) => {
        if (data?.data?.success) {
          setShowSuccessMessage(data.data.message);
          setApiReRender(true);
          filterToggle();
        }
      })
      .catch((err) => {
        console.error("Caught in catch block:", err);
        setModalTitle("Error");
        setModalBody(
          err?.response?.data?.message || 'Please try after sometime'
        );
        toggle();
      });

  };
  return (
    <div className="allotted-cases-details-page">
      <CommonNavbar title="Allotted Cases" backButton={path.ALLOTTED_CASES} search={false} download={false} navbarname='AssignedBlocksAllottedCases' />
      <div style={{ marginTop: "20px" }}></div>
      <CaseCard selectCards={selectedValue} />
      <ErrorAlert
        modal={modal}
        toggle={toggle}
        modalTitle={modalTitle}
        modalBody={modalBody}
      />
      <CardTabs tabData={tabList} onTabChange={(tabTitle) => setTabVal(tabTitle)} />
      {tabVal === "Investigation" && <p style={{ marginTop: "0.7rem", marginLeft: '0.5rem', color: "#E42125", textDecoration: 'underline', cursor: 'pointer', fontWeight: '500', fontSize: "14px", paddingTop: "50px" }} onClick={addInvestigatorHandler}>+ ADD INVESTIGATOR</p>}
      {open && (<FilterPopUp open={open} backgroundColor={'#8F949B80'} >
        <InvestigatorNameList onCancelHandler={() => filterToggle()} vendorDetails={vendorDetails} onAddHandler={(caseId, selectedEmpId) => assignInvestigatorHandler(caseId, selectedEmpId)} />
      </FilterPopUp>)}
      {showSuccessMessage && (
        <SuccessMessage message={showSuccessMessage} delay={3000} />
      )}
    </div >
  );
}

AllottedCasesDetailsPage.propTypes = {
  dispatch: PropTypes.func
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    updateCaseDetails: (data) => dispatch(caseDetails(data)),
    setApiReRender: (value) => dispatch(setApiReRenderAction(value))
  }
}

const mapStateToProps = createStructuredSelector({
  allottedCasesDetailsPage: makeSelectAllottedCasesDetailsPage(),
  allCases: makeSelectCardCasesPage()
});


const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(withConnect, memo)(AllottedCasesDetailsPage);
